import { Chip as MaterialUiChip } from '@material-ui/core';
import React, { FC } from 'react';
import TypographyWrapper, { TypographyWeight } from '../TypographyWrapper/TypographyWrapper';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

interface ChipProps {
  label: string;
  styleOverrides?: React.CSSProperties;
}

const Chip: FC<ChipProps> = (props) => {
  const { label, styleOverrides } = props;
  const defaultShopStyles = useDefaultShopStyles();
  const backgroundColor = defaultShopStyles.shopColor10;
  const borderCss = `1px solid ${defaultShopStyles.shopColor20}`;

  return (
    <MaterialUiChip
      style={{
        backgroundColor,
        borderRadius: '16px',
        border: borderCss,
        height: '20px',
        ...styleOverrides,
      }}
      label={
        <TypographyWrapper
          weight={TypographyWeight.Bold}
          variant="body2"
          typographyOverrides={{ style: { fontSize: '12px' } }}
        >
          {label}
        </TypographyWrapper>
      }
      size="small"
    />
  );
};

export default Chip;
